module.exports = __webpack_public_path__ + "static/backgroundHeader-7979229bc3991b295be0615e2bcc3906.mp4";